export default "__VITE_ASSET__gBx$p4dU__"